// extracted by css-extract-rspack-plugin
export default {"groupsTarget":"x3ZEQ"};